//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
    name: 'TopCurrency',
    data() {
        return {
        };
    },
    mounted() {
    },
    computed: {
        ...mapState([ 'topCurrency' ]),
    },
    methods: {
    },

};
